import { Grid } from "@mui/material";
import {
    required,
    SelectInput,
    TextInput,
} from "react-admin";

const SaveForm = () => {
    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                md={6}
                xs={12}
            >
                <TextInput
                    label="Име на български език"
                    source="nameBg"
                    validate={required()}
                />
            </Grid>
            <Grid
                item
                md={6}
                xs={12}
            >
                <TextInput
                    label="Име на английски език"
                    source="nameEn"
                    validate={required()}
                />
            </Grid>
            <Grid
                item
                md={6}
                sm={6}
                xs={12}
            >
                <SelectInput
                    source="type"
                    label="Вид стаж"
                    choices={[
                        { id: 1, name: "Летен" },
                        { id: 2, name: "Пред дипломен" },
                    ]}
                    optionText="name"
                    optionValue="id"
                />
            </Grid>
        </Grid>
    );
};
export default SaveForm;
